import React from 'react';

import { AutoCompleteProps as AntdAutoCompleteProps } from 'antd';
import { NamePath as AntdNamePath } from 'antd/lib/form/interface';

import {
  DepartementApiGouvOption,
  useSearchDepartementApiGouv,
} from 'hooks/search/useSearchDepartementApiGouv';
import { unsafeCast } from 'typeGuards/typeGuards';

import BaseAutocomplete, { AutocompleteDependencies } from './BaseAutocomplete';

interface AutocompleteDepartementProps<FormValues>
  extends Omit<
    AntdAutoCompleteProps<string, DepartementApiGouvOption>,
    'options'
  > {
  name: keyof FormValues & AntdNamePath & string;
  codeField?: keyof FormValues & AntdNamePath & string;
}

function buildValue(option: DepartementApiGouvOption): string {
  return `${option.nom} - ${option.code}`.trim();
}

export default function AutocompleteDepartement<FormValues>({
  name,
  codeField,
  onChange: _onChange,
  ...props
}: AutocompleteDepartementProps<FormValues>): React.ReactElement {
  return (
    <BaseAutocomplete<FormValues, DepartementApiGouvOption>
      {...props}
      optionsFetcher={useSearchDepartementApiGouv}
      buildValue={buildValue}
      getCurrentFieldValue={option => option.nom}
      name={unsafeCast<unknown>(name)}
      dependencies={
        unsafeCast<
          | AutocompleteDependencies<FormValues, DepartementApiGouvOption>[]
          | undefined
        >(codeField) && [
          {
            name: unsafeCast<unknown>(codeField),
            getValue: option => option.code,
          },
        ]
      }
    />
  );
}
